import ReactGA from "react-ga";

const useAnalysticsEventTracker = (category: string = "Category") => {
    const eventTracker = (action = "test action", label = "test label") => {
        ReactGA.event({ category, action, label });
    }
    return eventTracker;
};

export default useAnalysticsEventTracker;